//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation,EffectFade,EffectCreative,A11y,FreeMode,Thumbs,Autoplay,Keyboard} from 'swiper/modules';

//import swiper styles
import 'swiper/css/bundle';

//INTERIOR GALLERY w/ THUMBNAILS
const galleries = document.querySelectorAll('.gallery');
if( galleries ){

    galleries.forEach((gallery, index) => {

        let slider = gallery.querySelector('.js-gallery-slides');
        let thumbs = gallery.querySelector('.js-gallery-thumbs');
        let prev = gallery.querySelector('.swiper-button-prev');
        let next = gallery.querySelector('.swiper-button-next');

        const galleryThumbs = new Swiper(thumbs, {
            modules: [FreeMode],
            spaceBetween: 10,
            slidesPerView: 5,
            freeMode: true,
            watchSlidesProgress: true,
        });

        const galleryTop = new Swiper(slider, {
            modules: [EffectFade,Navigation,A11y,Thumbs,Keyboard],
            loop: false,
            fadeEffect: { crossFade: true },
            effect: 'fade',
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            // COMPLIANCE FIX: This forces Swiper to track visibility 
            // and apply aria-hidden="true" to inactive slides
            watchSlidesProgress: true,
            a11y: {
                enabled: true,
                containerRoleDescriptionMessage: 'carousel',
                itemRoleDescriptionMessage: 'slide',
                slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
            },
            navigation: {
                addIcons: false,
                nextEl: next,
                prevEl: prev,
            },
            thumbs: {
                swiper: galleryThumbs,
            },
            // COMPLIANCE FIX: Manually enforce ARIA attributes for the Fade Effect
            on: {
                init: function () {
                    toggleSlideA11y(this);
                    enforceButtonAccessibility(prev, next);
                },
                slideChange: function () {
                    toggleSlideA11y(this);
                    enforceButtonAccessibility(prev, next);
                },
                toEdge: function () {
                    enforceButtonAccessibility(prev, next);
                }
            }
        });

    });
    
}

// COMPLIANCE FIX: Overrides Swiper's aggressive button lockout
function enforceButtonAccessibility(prevBtn, nextBtn) {
    // We use a tiny timeout to ensure our code runs right AFTER Swiper modifies the DOM
    setTimeout(() => {
        [prevBtn, nextBtn].forEach(button => {
            if (button) {
                // 1. Remove the native disabled attribute so focus isn't lost
                button.removeAttribute('disabled');
                
                // 2. Force the button back into the keyboard tab order
                button.setAttribute('tabindex', '0');
            }
        });
    }, 0);
}

// Helper function to handle the attribute swapping
function toggleSlideA11y(swiperInstance) {
    swiperInstance.slides.forEach(slide => {
        // Check if this specific slide is the active one
        if (slide.classList.contains('swiper-slide-active')) {
            slide.setAttribute('aria-hidden', 'false');
            slide.removeAttribute('tabindex'); // Accessible to screen readers/keyboards
        } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('tabindex', '-1'); // Hidden from screen readers/keyboards
        }
    });
}
